import { Base } from "../Base";
import { system } from "../system";
import { Properties } from "./Properties";
export class Class extends Base {
    properties;
    class = "object";
    _name;
    get name() {
        return (this._name ??= Properties.getName(this.properties));
    }
    get definition() {
        return Object.assign(super.definition, {
            properties: system.Object.fromEntries(Properties.entries(this.properties).map(([p, t]) => [p, t.definition])),
        });
    }
    constructor(properties, name) {
        super();
        this.properties = properties;
        this._name = name;
    }
    is(value) {
        return (!!value &&
            typeof value == "object" &&
            !Array.isArray(value) &&
            system.Object.entries(this.properties).every(([property, type]) => type.is(value[property])));
    }
    prune(value) {
        return this.is(value) ? Properties.prune(this.properties, value) : undefined;
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: Object.entries(this.properties)
                .map(([property, type]) => [property, type.flawed(value?.[property])])
                .map(([property, flaw]) => flaw && { ...flaw, property })
                .filter((f) => !!f),
        });
    }
    extend(properties, name) {
        return this.modify({
            properties: { ...this.properties, ...properties },
            name: name ?? `${this.name} & ${Properties.getName(properties)}`,
        });
    }
    omit(omits, name) {
        return this.modify({
            properties: Class.omit(this.properties, omits),
            name: name ?? `Omit<${this.name}, ${omits.map(key => `"${key.toString()}"`).join(" | ")}>`,
        });
    }
    pick(picks, name) {
        return this.modify({
            properties: Class.pick(this.properties, picks),
            name: name ?? `Pick<${this.name}, ${picks.map(key => `"${key.toString()}"`).join(" | ")}>`,
        });
    }
    partial(name) {
        return this.modify({
            properties: Properties.optional(this.properties),
            name: name ?? `Partial<${this.name}>`,
        });
    }
    modify(type) {
        const result = super.modify(type);
        return Object.assign(result, {
            extend: type?.extend ?? this.extend,
            omit: type?.omit ?? this.omit,
            pick: type?.pick ?? this.pick,
        });
    }
    bind() {
        const result = super.bind();
        return Object.assign(result, {
            extend: this.extend.bind(this),
            omit: this.omit.bind(this),
            pick: this.pick.bind(this),
        });
    }
    static create(properties, name) {
        return new Class(properties, name);
    }
}
(function (Class) {
    function omit(object, omits) {
        const keys = system.Object.keys(object).filter(k => omits.every(omit => omit != k));
        return pick(object, keys);
    }
    Class.omit = omit;
    function pick(object, picks) {
        return system.Object.fromEntries(picks.map(key => [key, object[key]]));
    }
    Class.pick = pick;
})(Class || (Class = {}));
//# sourceMappingURL=Class.js.map